<template>
  <div class="pick-hero">
    <div class="pick-hero__body">
      <div class="pick-hero__question">
        Вы уверены что хотите {{ actionWord }} персонажа?
      </div>
      <div class="pick-hero__hero">
        <Hero class="pick-hero__hero-img" :hero="hero" />
        <div class="pick-hero__hero-name">{{ hero.name }}</div>
      </div>
    </div>

    <AppBtn
      class="pick-hero__btn"
      color="red-grad"
      round
      :loading="loading"
      @click="pickHero"
    >
      {{ actionWord }}
    </AppBtn>
  </div>
</template>

<script>
import showAlert, { requestErrorAlert } from "@/services/common/showAlert";
import { asyncModal } from "@/components/ui/modal/utils";
import Hero from "./Hero";
import service from "@/services/match";
import { mapGetters } from "vuex";
import { ActionWords } from "./types";

const PickHero = {
  name: "PickHero",
  components: {
    Hero
  },
  props: {
    action: {
      type: Number,
      required: true,
      validator: val => !!ActionWords[val]
    },
    hero: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters("tournaments", ["match"]),
    actionWord() {
      return ActionWords[this.action].completeAction;
    }
  },
  methods: {
    async pickHero() {
      this.loading = true;
      try {
        const { success, message } = await service.pickHero(
          this.match.id,
          this.hero.id
        );
        if (success) {
          this.$modals.close();
        } else {
          this.$modals.close();
          showAlert(message);
        }
      } catch (e) {
        console.log(e);
        requestErrorAlert();
      }
      this.loading = false;
    }
  },
  sockets: {
    pick_ban_hero() {
      this.$modals.close();
      showAlert(
        "Вы не успели выбрать героя в установленное время, он был выбран автоматически."
      );
    }
  }
};

export function openPickHeroModal({ hero, action }) {
  return asyncModal({
    name: "pick-hero-modal",
    component: PickHero,
    props: {
      hero,
      action
    }
  });
}

export default PickHero;
</script>

<style lang="scss">
.pick-hero-modal {
  .modal-card {
    max-width: 100%;
    width: 800px;
    padding: 0;
  }
}

.pick-hero {
  width: 780px;
  max-width: 100%;
  padding: 33px 15px;

  &__body {
    padding: 18px 35px;
    background: #000a25;
    border-radius: 5px;
    width: 600px;
    max-width: 100%;
    margin: 0 auto 30px;
    display: flex;
    align-items: center;
  }

  &__question {
    font-size: 24px;
    font-weight: 700;
    font-family: "Montserrat";
    line-height: 29px;
    text-align: right;
    width: 335px;
    margin-right: 25px;
  }

  &__hero {
    width: 190px;
    height: 125px;
    background: #0f1a39;
    border: 2px solid #414a65;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 13px;
  }

  &__hero-img {
    width: 92px;
    height: 54px;
  }

  &__hero-name {
    font-family: "Montserrat";
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: #fbc33e;
    text-align: center;
    margin-top: 10px;
  }

  &__btn {
    width: 174px;
    height: 46px;
    font-size: 20px;
    font-family: "Montserrat";
    margin: 0 auto;
    display: flex;
  }

  @include breakpoint("sm-and-down") {
    &__body {
      flex-direction: column;
      align-items: center;
    }
    &__question {
      margin-right: 0;
      margin-bottom: 20px;
      text-align: center;
      width: 100%;
    }
  }

  @include breakpoint("xs-only") {
    &__body {
      padding: 15px;
    }
    &__question {
      font-size: 18px;
    }
  }
}
</style>
